import { useEffect } from 'react';

export type ToastVariant = 'ok' | 'info' | 'warn' | 'err';

export interface ToastProps {
  variant: ToastVariant;
  message: string;
  autoHideMs?: number;
  onClose?: () => void;
}

export function Toast({ variant, message, autoHideMs = 3000, onClose }: ToastProps): JSX.Element {
  useEffect(() => {
    if (autoHideMs <= 0) return;
    const id = window.setTimeout(() => { onClose?.(); }, autoHideMs);
    return () => window.clearTimeout(id);
  }, [autoHideMs, onClose]);

  const icon = variant === 'ok' ? '✓' : variant === 'warn' ? '⚠' : variant === 'err' ? '✗' : 'ℹ';

  return (
    <div className={`toast toast-${variant}`} role="status" aria-live="polite">
      <span style={{ fontSize: 16, color: `var(--${variant === 'ok' ? 'pcb-green' : variant === 'err' ? 'pcb-red' : variant === 'warn' ? 'pcb-amber-text' : 'pcb-blue'})` }}>
        {icon}
      </span>
      <div style={{ flex: 1 }}>{message}</div>
    </div>
  );
}
